<template lang="pug">
  .component-driver-reservation-request(v-if="item")
    .card
      .inner-content(v-if="$is('listing')" )

      .inner-content(v-if="$is('reservation')" )
        .row
          .column.shrink
            dropdown(:icon="'fa fa-ellipsis-v fa-2x action'", :position="'bottom'")
              PreauthButtons(:item="item")
          .column.shrink
            .label PR{{item.id}}
          .column
            .label Amount
            .value {{$priceWithcurrency(item.amount)}}
          .column
            .label Status
            .value {{item.status}}
          .column
            .label Process on
            .value {{item.process_on}}
          .column
            .label Expiry
            .value {{item.expiry}}
</template>

<script>
import Dropdown from '../structure/foundation/Dropdown'
import ChargingSessionButtons from "../structure/ui/actions/ChargingSessionButtons.vue";
import PreauthButtons from "../structure/ui/actions/PreauthButtons.vue";

export default {
  name: 'ChargingSession',
  components: {PreauthButtons, ChargingSessionButtons, Dropdown},
  props: {
    item: Object,
    type: {
      type: String,
      default: ''
    }
  },
}
</script>

<style lang="sass">
.component-driver-reservation-request
  .fa-check
    color: green

  .fa-times
    color: red
</style>



// WEBPACK FOOTER //
// Preauth.vue?d66c2e72